import * as React from "react";
const SvgFiRrGym = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gym_svg__a)">
      <path
        fill="#062147"
        d="M22.942 6.837 20.76 4.654l.947-.947a1 1 0 1 0-1.414-1.414l-.947.947-2.183-2.182a3.7 3.7 0 0 0-5.105 0 3.61 3.61 0 0 0 0 5.106l2.182 2.182-5.894 5.894-2.183-2.182a3.7 3.7 0 0 0-5.105 0 3.61 3.61 0 0 0 0 5.106l2.182 2.182-.947.947a1 1 0 1 0 1.414 1.414l.947-.947 2.183 2.182a3.61 3.61 0 1 0 5.105-5.105L9.76 15.655l5.9-5.895 2.182 2.182a3.61 3.61 0 1 0 5.105-5.105zM11 20.39a1.6 1.6 0 0 1-.472 1.138 1.647 1.647 0 0 1-2.277 0l-5.779-5.78a1.61 1.61 0 0 1 2.277-2.276l5.78 5.779A1.6 1.6 0 0 1 11 20.39m10.528-9.862a1.647 1.647 0 0 1-2.277 0l-5.779-5.78a1.61 1.61 0 0 1 2.277-2.276l5.78 5.779a1.61 1.61 0 0 1 0 2.277"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gym_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGym;
